import { Grid, Box, Typography, Button } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { UploadResponseItem } from '../../models/cloudinary.models';
import { cloudinaryInstance } from '../../utils/images.tsx';
import './StyleBoard.scss';

interface StyleBoardImageProps {
  image: UploadResponseItem;
  index: number;
  openModal: (image: UploadResponseItem) => void;
  openDeleteModal: (image: UploadResponseItem) => void;
}

export const StyleBoardImage = ({
  image,
  index,
  openModal,
  openDeleteModal,
}: StyleBoardImageProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: index });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Grid
      key={index}
      ref={setNodeRef}
      style={style}
      size={{
        xs: 12,
        md: 6,
        lg: 4,
      }}
      {...attributes}
      {...listeners}
    >
      <Box
        className="image"
        sx={{
          backgroundImage: `url(${cloudinaryInstance.image(image.public_id).toURL()})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '324px',
        }}
      >
        <Box className="overlay">
          <CloseOutlined
            onClick={() => openDeleteModal(image)}
            className="delete-button"
          />
          <Button className="buttons" onClick={() => openModal(image)}>
            <EditNoteIcon sx={{ width: '40px', height: '40px' }} />
            <Typography sx={{ fontSize: '12px' }}>
              Add/View Description
            </Typography>
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};
